// extracted by mini-css-extract-plugin
export default {"list":"ObjectList_list__Mh74E"};